module.exports = __webpack_public_path__ + "img/National_Seminar_Nov_2021.fc3528f6.jpg";